import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import {
  Menu,
  CoreLink,
} from '@uncinc/react-drupal-core';

import { MENU_NL } from '../../../config/constants';

import './style.scss';

const SubtreeMenuItem = ({
  subtreeItem,
  subtreeItemIndex,
  setActiveOverlayMenu,
}) => {
  const subtreeItemUrl = subtreeItem.getIn(['link', 'url'], '');
  const subtreeItemTitle = subtreeItem.getIn(['link', 'title']);
  const subtreeItemUrlIsExternal = subtreeItem.getIn(['link', 'route_parameters'], Immutable.Map()).size === 0;

  return (
    <div key={`subtreeitem-${subtreeItemIndex}`} className="MainMenuOverlay__subtree__item">
      <span className={`icon icon-${subtreeItemUrlIsExternal ? 'external-link' : 'arrow-right'} icon-variant-2`} />
      <CoreLink
        primary
        href={subtreeItemUrl}
        onClick={() => setActiveOverlayMenu(null)}
      >
        {subtreeItemTitle}
      </CoreLink>
    </div>
  );
};

const MainMenuOverlay = ({
  setActiveOverlayMenu,
  overlayRefs,
}) => {
  const { t } = useTranslation();

  return (
    <div className="MainMenuOverlay">
      <Menu id={MENU_NL}>
        {(items) => {
          return (
            <div className="MainMenuOverlay__wrapper">
              {items.map((item, index) => {
                if (item) {
                  const id = item.getIn(['link', 'meta_data', 'entity_id']);
                  const title = item.getIn(['link', 'title']);
                  const description = item.getIn(['link', 'description'], '');
                  const dropdownButtonText = item.getIn(['link', 'options', 'attributes', 'dropdown_button_text'], t('general.read_more'));
                  const url = item.getIn(['link', 'url'], '');
                  const subtree = item.get('subtree', Immutable.Map());
                  const MainMenuOverlayItemClassnames = c(
                    'MainMenuOverlay__item',
                    `MainMenuOverlay__index__${index}`,
                  );

                  return (
                    <div
                      key={id}
                      ref={overlayRefs[index]}
                      className={MainMenuOverlayItemClassnames}
                    >
                      <div className="row">
                        <div className="col-12">
                          <CoreLink
                            className="MainMenuOverlay__item__link"
                            href={url}
                            onClick={() => setActiveOverlayMenu(null)}
                          >
                            <h3 className="MainMenuOverlay__title">
                              {title}
                            </h3>
                          </CoreLink>
                        </div>
                        <div className="col-12 col-lg-4">
                          {description && (
                            <div className="MainMenuOverlay__body">
                              {description}
                            </div>
                          )}
                          <CoreLink
                            className="Button Button--primary"
                            href={url}
                            onClick={() => setActiveOverlayMenu(null)}
                          >
                            {dropdownButtonText}
                          </CoreLink>

                        </div>
                        <div className="col-12 col-lg-8">
                          <div className="MainMenuOverlay__subtree">
                            <div className="MainMenuOverlay__subtree__left">
                              {subtree.map((subtreeItem, subtreeItemIndex) => {
                                if (subtreeItemIndex + 1 > Math.ceil(subtree.size / 2)) {
                                  return;
                                }

                                return (
                                  <SubtreeMenuItem
                                    subtreeItem={subtreeItem}
                                    subtreeItemIndex={subtreeItemIndex}
                                    setActiveOverlayMenu={setActiveOverlayMenu}
                                  />
                                );
                              })}
                            </div>
                            <div className="MainMenuOverlay__subtree__right">
                              {subtree.map((subtreeItem, subtreeItemIndex) => {
                                if (subtreeItemIndex < Math.ceil(subtree.size / 2)) {
                                  return;
                                }

                                return (
                                  <SubtreeMenuItem
                                    subtreeItem={subtreeItem}
                                    subtreeItemIndex={subtreeItemIndex}
                                    setActiveOverlayMenu={setActiveOverlayMenu}
                                  />
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          );
        }}
      </Menu>
    </div>
  );
};

export default MainMenuOverlay;
